export const BROWSE_PAGE_SIZE = 20;
export const MAX_AGGREGATION_VALUES = 100;

export const BROWSE_LOAD_MORE_MARGIN = '200px';
